angular.module("app").factory("httpHandler", [
    'userStorage',
    'settingsService',
    '$location',
    '$rootScope',
    function (userStorage, settingsService, $location, $rootScope) {
        var depricated = false;
        return {
            request: function (request) {
                if (request.url.search("views") === 0 && request.url.indexOf(".html") != -1) {
                    request.url += '?version=' + new Date().getTime()
                }
                depricated = false;
                return request
            },
            response : function (response) {
                if (!depricated && response && response.data && (response.data.logout || (response.data.error && response.data.error.logout))) {
                    depricated = true;
                    userStorage.resetUserData();
                    settingsService.reset();
                    $rootScope.$broadcast("force:logout");
                    $location.url("login");
                }
                return response
            }
        };
    }
]).config(['$httpProvider', function($httpProvider) {
    $httpProvider.interceptors.push('httpHandler');
}]);